
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { VForm } from '../../global/vuetify.types'

interface ResetPasswordData {
  password: string;
  confirmPassword: string;
  token?: string;
  mfaToken?: string;
}

@Component
export default class PasswordResetForm extends Vue {
  @Prop({ type: String, default: null })
  private readonly error!: string

  formData: ResetPasswordData = {
    password: '',
    confirmPassword: ''
  }

  valid = true

  showPass = false

  showPassConfirm = false

  get passwordRules() {
    return [
      (v: string) => !!v || 'Password is required',
      (v: string) => (v && v.length >= 7) || 'Password must be at least 7 characters'
    ]
  }

  get confirmPasswordRules() {
    return [
      (v: string) => !!v || 'Confirmation is required',
      (v: string) => v === this.formData.password || 'Passwords must match'
    ]
  }

  get form() {
    return this.$refs.form as VForm
  }

  submit() {
    if (this.form.validate()) {
      this.$emit('submit', this.formData)
    }
  }
}
